module.exports = {"br.com.neolog.model.Vehicle":"vehicle","br.com.neolog.model.Locality":"locality"}